import { Modal } from "@mui/material";
import styled from "styled-components";
import { COLORS, responsive, THEME } from "../../styles/constants.style";

export const MuiModalWrapper = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;

  .hide-modal {
    visibility: hidden;
    opacity: 0;
  }

  .sub-container {
    display: flex;
    flex-direction: column;
    width: 600px;
    background-color: ${COLORS.cirrus_white};
    border-radius: 8px;

    ${responsive.MOBILE`
        width: 352px;
        max-height:100vh;
        overflow:auto;
    `}
  }

  .MuiTabs-flexContainer {
    background-color: ${COLORS.cirrus_white};
  }

  .accordion-header-text {
    padding: 10px 16px;
  }

  .info-box {
    background-color: ${COLORS.cirrus_white};
  }

  .modal-container {
    padding: 0px 16px;

    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .add-overflow {
    overflow: auto;
  }
  .close-image {
    color: ${COLORS.primary_light_blue};
  }

  .large-sub-container {
    width: 1040px;
    max-height: calc(100vh - 80px);
    overflow: auto;
    word-break: break-all;
    margin: 16px;

    ${responsive.TABLET_PORTRAIT`
      width: 760px;
    `}

    ${responsive.MOBILE`
      width: 352px;
    `}
    .modal-container {
      padding: 0px;
    }
  }

  .parent-hierarchy-box {
    ${responsive.MOBILE`
      display: flex;
      flex-direction: column;
      max-width: calc(100% - 80px);
      overflow: hidden;
      .ellipsis-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
    }
    `}
  }

  .subtitle-text {
    ${responsive.MOBILE`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      font-family: ${THEME.fontFamilies.primary} !important;
      font-size: ${THEME.fontSizes[300]} !important;
   `}
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    border-bottom: 1px solid ${COLORS.cirrus_black3};
    padding: 16px 12px 16px 16px;

    ${responsive.MOBILE`
       margin-top: 0px;
       margin-bottom: 0px;
       gap: 5px;
       padding: 16px;
    `}

    .btn-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      ${responsive.MOBILE`
            justify-content: flex-end;
            gap: 4px;
        `}

      .view-buttons-container {
        display: flex;
        gap: 2px;
        margin-right: 32px;
        border: 1px solid ${COLORS.primary_light_blue};
        border-radius: 8px;

        ${responsive.MOBILE`
            margin-right: 0;
          `}
        button {
          border-radius: 0;
          background-color: ${COLORS.primary_light_blue};

          ${responsive.MOBILE`
              height: 36px;
              width: 36px;
           `}
        }

        button:first-child {
          border-top-left-radius: 7px;
          border-bottom-left-radius: 7px;
        }

        button:last-child {
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
          height: 40px;
          width: 40px;

          ${responsive.MOBILE`
              height: 36px;
              width: 36px;
           `}
        }

        button svg {
          fill: ${COLORS.cirrus_white};
        }

        button:last-child svg {
          stroke: ${COLORS.cirrus_white};
        }

        button.active {
          background-color: ${COLORS.primary_light_blue1};
        }

        button.active svg {
          fill: ${COLORS.primary_light_blue};
        }

        button:last-child.active svg {
          stroke: ${COLORS.primary_light_blue};
        }
      }
    }
  }

  .no-hierarchy-container {
    min-height: 445px;
    background-color: ${COLORS.cirrus_white};
    border-bottom: 1px solid ${COLORS.cirrus_black3};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    .MuiTypography-root {
      line-height: 21.78px;
      text-align: center;
      color: ${COLORS.cirrus_black};
    }
    .MuiTypography-root:first-of-type {
      margin-top: 24px;
    }

    ${responsive.MOBILE`
      padding: 0 16px;
      overflow-x: hidden;
      word-break: break-word;
  `}
  }

  .large-header {
    margin-bottom: 0px;

    ${responsive.MOBILE`
      padding: 16px;
    `}
  }

  .text-title {
    width: 70%;
    color: ${COLORS.cirrus_black};
  }

  .modal-button-container {
    display: flex;
    flex: 1;
    gap: 16px;
    padding: 32px 16px 20px;
    justify-content: space-between;
    ${responsive.MOBILE`
       gap: 0px;
       padding: 16px;
      `}

    .btn-sub-container {
      display: flex;
      flex: none;
      gap: 16px;
      align-items: end;

      ${responsive.MOBILE`
        flex-direction: column-reverse;
      `}
    }

    .bottom-children {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex: 1;
      padding: 8px 16px;
      background-color: ${COLORS.cirrus_red_mild1};
      border: 1px solid ${COLORS.cirrus_red_mild2};
      border-radius: 8px;

      .error-container {
        display: flex;
        align-items: center;
      }

      .error-cross-icon {
        display: flex;
        align-items: center;
        margin: 10px;
      }

      .error-container .MuiTypography-root.error {
        display: flex;
        align-items: center;
        color: ${COLORS.cirrus_red};
        line-height: 20px;
        word-break: break-word;
      }
    }

    .full-width {
      width: auto;
      &.tertiary {
        background-color: ${COLORS.cirrus_white};
        ${responsive.MOBILE`
          background: ${COLORS.primary_light_blue};
          color: ${COLORS.cirrus_white};
        `}
      }

      ${responsive.MOBILE`
        width: 100%;
      `}
    }

    ${responsive.MOBILE`
        flex-direction: column-reverse;
    `}
  }

  .responsive-button-container {
    ${responsive.MOBILE`
      .btn-sub-container {
        flex-direction: column;
      }
    `}
  }

  .large-button-container {
    padding-right: 16px;
    border-top: 1px dashed ${COLORS.primary_light_blue};
    ${responsive.MOBILE`
      padding: 16px;
    `}
  }

  .full-width {
    &.action-tertiary {
      background-color: ${COLORS.cirrus_white};
      ${responsive.MOBILE`
        color: ${COLORS.primary_light_blue};
      `}
    }
    ${responsive.MOBILE`
      width: 100%;
    `}
  }

  .view-locale-modal,
  .manage-local-modal {
    .header {
      margin-bottom: 8px;
    }
    width: 1040px;
    ${responsive.SMALL_LAPTOP`
      width: 700px;
    `}
    ${responsive.MOBILE`
      width: calc(100% - 40px);
      margin:auto;
    `}
    .modal-container {
      padding: 0px;
    }
  }

  .view-user-modal,
  .add-user-modal {
    .modal-container {
      ${responsive.MOBILE`
       margin-top: 0px;
      `}
    }
  }

  .view-contact-modal,
  .add-new-contact-modal,
  .upload-new-document-modal,
  .view-document-modal,
  .view-fee-expense-modal,
  .add-fees-and-expense-modal,
  .mdm-view-top-details-modal,
  .add-edit-mdm-topic-details,
  .mdm-add-activity-modal,
  .mdm-view-activity-modal,
  .mdm-office-view-modal,
  .mdm-create-office-modal,
  .purchase-order-manage-transaction {
    .modal-container {
      ${responsive.MOBILE`
        margin-top: 0 !important;
      `}
    }
  }

  .mdm-office-view-modal,
  .mdm-view-activity-modal,
  .project-view-activity-modal {
    .btn-sub-container {
      ${responsive.MOBILE`
      flex-direction: column;
    `}
    }
  }

  .view-invoice-history-btn {
    .full-width.tertiary {
      ${responsive.MOBILE`
        background: ${COLORS.cirrus_white};
        color: ${COLORS.primary_light_blue};
    `}
    }
  }

  // added this class here for modal popup component
  .grid-size-large {
    padding-right: 16px;
    margin-top: 40px;
    &:nth-child(-n + 2) {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 24px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+1) {
        margin-top: 16px;
      }
    `}
  }
  .grid-size-medium {
    padding-right: 16px;
    margin-top: 24px;

    ${responsive.MOBILE`
      padding-right: 0px;
    `}

    &:nth-child(-n + 3) {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 24px;
      }
      &:nth-child(n+3) {
        margin-top: 24px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    `}
  }

  .warning-modal-for-locale {
    width: 650px;
    ${responsive.MOBILE`
      width: 352px;
    `}
  }
`;

export const InformationWrapper = styled.div`
  .confirm-message {
    color: ${COLORS.cirrus_black10};
    line-height: 22px;
  }
`;
